import { isKingCheckmated } from '../../utilities/isKingCheckmated';
const lookForCheckmate = (context, event) => {
    let isCheckmate = false;
    if (event.type === 'MOVE') {
        const playersKingSquare = context.board.find((square) => { var _a, _b; return ((_a = square.piece) === null || _a === void 0 ? void 0 : _a.type) === 'king' && ((_b = square.piece) === null || _b === void 0 ? void 0 : _b.color) === context.player; });
        isCheckmate = isKingCheckmated(playersKingSquare, context);
    }
    return { isCheckmate };
};
export { lookForCheckmate };
